import {OverflowMenuOption} from 'ui-library/menus/OverflowMenu';

import {
  ActionFunctionParameters,
  OverflowMenuActionFunction,
  ToolbarButtonActionFunction,
} from '../StructuredTableConstants';

export interface MakeCustomButtonActionFunctionParams<TTableMetadata, TRowMetadata> {
  // Return whether the button should be hidden completely.
  getHidden?: (params: ActionFunctionParameters<TTableMetadata, TRowMetadata>) => boolean;

  // Component to render as the action button
  renderToolbarButton: (
    actionFunctionParams: ActionFunctionParameters<TTableMetadata, TRowMetadata>
  ) => JSX.Element;

  // Component to render as the menu item in the overflow menu
  renderOverflowMenuItem: (
    actionFunctionParams: ActionFunctionParameters<TTableMetadata, TRowMetadata>
  ) => OverflowMenuOption;
}

/**
 * Create an ActionFunction that can be placed in either the toolbar or the overflow menu.
 */
export default function makeCustomButtonActionFunction<TTableMetadata, TRowMetadata>({
  getHidden,
  renderToolbarButton,
  renderOverflowMenuItem,
}: MakeCustomButtonActionFunctionParams<TTableMetadata, TRowMetadata>): ToolbarButtonActionFunction<
  TTableMetadata,
  TRowMetadata
> &
  OverflowMenuActionFunction<TTableMetadata, TRowMetadata> {
  return {
    renderToolbarButton: (params) => {
      if (getHidden?.(params)) {
        return null;
      }
      return renderToolbarButton(params);
    },

    getOverflowMenuItem: (params) => {
      if (getHidden?.(params)) {
        return null;
      }
      return renderOverflowMenuItem(params);
    },
  };
}
